<template>
  <div class="chat-service-container"
       v-show="visible">
    <!-- 悬浮图标 -->
    <div v-if="!expanded"
         class="chat-icon-wrapper"
         @click.stop="toggleExpand">
      <!-- 消息气泡 -->
      <div class="message-bubble"
           v-show="showMessageBubble">
        <div class="bubble-content">
          <div class="bubble-number">1</div>
        </div>
      </div>

      <!-- 悬浮图标主体 -->
      <div class="chat-icon">
        <div class="ripple-effect"></div>
        <div class="ripple-effect-2"></div>
        <img src="../../assets/chatlogo.png"
             alt="service" />

        <!-- Chat Now 提示 -->
        <div class="chat-now-label">
          <span style="font-size: 12px; font-weight: normal;">{{ $t('chatService.chatNow.label') }}</span>
        </div>
      </div>
    </div>

    <!-- 聊天窗口 -->
    <div v-else
         class="chat-window"
         :class="{ 
        'mobile': isMobile, 
        'tablet': isTablet, 
        'laptop': isLaptop 
      }">
      <!-- 头部 -->
      <div class="chat-header">
        <div class="header-left">
          <img src="../../assets/chatlogo2.png"
               class="header-icon" />
          <div class="header-info">
            <div class="header-title">Hey~ I'm your smart assistant.</div>
            <div class="header-status">
              <span v-if="isConnected"
                    class="status-connected">● Online Service</span>
              <span v-else
                    class="status-disconnected">● Connecting...</span>
            </div>
          </div>
        </div>
        <div class="header-right"
             @click="toggleExpand">
          <i><img src="../../assets/h.png"
                 alt=""
                 width="24"
                 height="14"></i>
        </div>
      </div>

      <!-- 内容区 -->
      <div class="chat-content"
           ref="chatContent">
        <div v-for="(message, index) in messages"
             :key="index"
             class="message-item"
             :class="message.type">
          <div class="message-info"
               :class="message.type">
            <template v-if="message.type === 'service'">
              <img :src="message.avatar"
                   class="message-avatar" />
              <span class="message-name">{{ message.name }}</span>
              <span class="message-time">{{ message.time }}</span>
            </template>
            <template v-else>
              <span class="message-time">{{ message.time }}</span>
              <span class="message-name">{{ message.name }}</span>
              <img :src="message.avatar"
                   class="message-avatar" />
            </template>
          </div>
          <div class="message-content">{{ message.content }}</div>
        </div>
      </div>

      <!-- 邮箱门禁遮罩层 -->
      <div v-if="emailGateVisible"
           class="email-gate-overlay">
        <div class="email-gate-dialog">
          <div class="email-gate-title">{{ $t('chatService.emailGate.title') }}</div>
          <div class="email-gate-desc">{{ $t('chatService.emailGate.desc') }}</div>
          <div class="email-gate-form">
            <input class="email-input"
                   v-model="emailInput"
                   :placeholder="$t('globalContactForm.placeholders.email')"
                   @keyup.enter="handleSubmit" />
            <div class="email-gate-actions">
              <button class="email-submit-btn"
                      @click="handleSubmit">{{ $t('globalContactForm.submit') }}</button>
              <button class="email-cancel-btn"
                      @click="cancelEmailGate">{{ $t('common.cancel') }}</button>
            </div>
          </div>
        </div>
      </div>

     

      <!-- 输入框 -->
      <div class="chat-input-area">
        <!-- 语言提示 -->
        <div class="language-tip">
          💡 input "中文" to switch to Chinese mode.
        </div>
        <div class="input-row">
          <input class="chat-input"
                 v-model="inputMessage"
                 @keyup.enter="sendMessage"
                 placeholder="Please enter your question"
                 ref="chatInput" />
          <div class="send-btn"
               @click="sendMessage">
            <img src="../../assets/submit.png"
                 class="send-icon" />
            <span>Send</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { emailSubmitApi, difyChatApi } from '@/api'

export default {
  name: "ChatService",
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      expanded: false,
      inputMessage: "",
      messages: [
        {
          type: "service",
          avatar: require("../../assets/chatlogo.png"),
          name: "service001",
          time: new Date().toLocaleString(),
          content: "Hello, how can I help you?",
        },
      ],
      isConnected: false,
      difyConversationId: '',
      difyUserId: '',
      difyAbortController: null,
      isSending: false,
      isMobile: false,
      isTablet: false,
      isLaptop: false,
      guessExpanded: true,
      loading: false,
      error: false,
      currentLanguage: 'en', // 新增：当前语言
      questions: [
        // 添加一些测试数据，以防API失败
        {
          id: 1,
          question: "What product lines do you offer?",
          answer: "We offer various laser cutting machines...",
          url: null,
          createTime: "2025-01-01T00:00:00",
          clearUrl: null
        },
        {
          id: 2,
          question: "你们提供什么产品线？",
          answer: "我们提供各种激光切割机...",
          url: null,
          createTime: "2025-01-01T00:00:00",
          clearUrl: null
        }
      ], // 新增：存储API获取的问题
      showMessageBubble: false, // 控制消息气泡的显示
      bubbleTimer: null, // 消息气泡定时器
      hasUserClicked: false, // 标记用户是否点击过
      // 联系信息请求消息
      contactInfoMessage: "Hello! We are glad that you asked us a question. In order to ensure that you can receive our reply in time and any subsequent questions can be answered, would you please leave your contact information (mobile phone number or email address)? We will serve you wholeheartedly.",
      // 标记是否已经发送过联系信息请求
      hasSentContactRequest: false,
      // 邮箱门禁
      emailGateVisible: false,
      emailSubmitted: false,
      emailInput: '',
    };
  },
  mounted() {
    this.difyUserId = this.getOrCreateDifyUserId()
    this.difyConversationId = this.getStoredDifyConversationId()
    this.isConnected = this.canUseDify()
    this.checkMobileDevice();
    this.adjustWindowSize();
    window.addEventListener('resize', this.adjustWindowSize);
    this.fetchQuestions(); // 组件挂载时调用获取问题

    // 启动时显示消息气泡
    setTimeout(() => {
      this.showMessageBubble = true;
    }, 1000);

    // 读取本地提交标记
    try {
      const flag = localStorage.getItem('chatEmailSubmitted');
      this.emailSubmitted = flag === 'true';
    } catch (e) {
      this.emailSubmitted = false;
    }
  },
  beforeDestroy() {
    if (this.difyAbortController) {
      this.difyAbortController.abort()
      this.difyAbortController = null
    }
    window.removeEventListener('resize', this.adjustWindowSize);
    this.showMessageBubble = false; // 组件销毁时隐藏消息气泡
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        // 展开时隐藏消息气泡并标记用户已点击
        this.showMessageBubble = false;
        this.hasUserClicked = true;
        // 滚动到底部
        this.$nextTick(this.scrollToBottom);
        // 若尚未提交邮箱，显示门禁遮罩
        if (!this.emailSubmitted) {
          this.emailGateVisible = true;
        }
      } else {
        // 收起时，如果用户已经点击过，则10秒后重新显示气泡
        if (this.hasUserClicked) {
          setTimeout(() => {
            this.showMessageBubble = true;
            // 5秒后自动隐藏
            setTimeout(() => {
              this.showMessageBubble = false;
            }, 5000);
          }, 10000); // 10秒后显示
        } else {
          // 如果用户还没点击过，立即显示
          this.showMessageBubble = true;
        }
        // 收起时关闭门禁遮罩
        this.emailGateVisible = false;
      }
    },
    async sendMessage() {
      // 未提交邮箱，阻止发送并提示
      if (!this.emailSubmitted) {
        this.emailGateVisible = true;
        this.$message.warning(this.$t('about.finance.contact.validation.emailRequired'));
        return;
      }
      if (!this.inputMessage.trim()) return;
      if (this.isSending) {
        if (this.canUseDify() && this.difyAbortController) {
          this.difyAbortController.abort()
          this.difyAbortController = null
          this.isSending = false
        } else {
          return
        }
      }

      const userMsg = this.inputMessage.trim();

      // 重置联系信息请求标志，允许新的对话发送联系信息请求
      this.hasSentContactRequest = false;

      // 添加用户消息到界面
      this.messages.push({
        type: "user",
        avatar: require("../../assets/tx.png"),
        name: "User",
        time: new Date().toLocaleString(),
        content: userMsg,
      });

      // 清空输入框并滚动到底部
      this.inputMessage = "";
      this.$nextTick(this.scrollToBottom);

      if (this.canUseDify()) {
        if (this.difyAbortController) {
          this.difyAbortController.abort()
          this.difyAbortController = null
        }

        const assistantMsg = {
          type: "service",
          avatar: require("../../assets/chatlogo.png"),
          name: "service 001",
          time: new Date().toLocaleString(),
          content: "",
        }
        this.messages.push(assistantMsg)
        this.$nextTick(this.scrollToBottom)

        const abortController = new AbortController()
        this.difyAbortController = abortController
        this.isSending = true

        try {
          await difyChatApi.streamChatMessage({
            query: userMsg,
            conversationId: this.difyConversationId,
            user: this.difyUserId,
            onDelta: (delta) => {
              assistantMsg.content = `${assistantMsg.content || ''}${delta || ''}`
              this.$nextTick(this.scrollToBottom)
            },
            onMeta: (meta) => {
              if (meta && meta.conversationId) {
                this.setStoredDifyConversationId(meta.conversationId)
                this.difyConversationId = meta.conversationId
              }
            },
            onEnd: (meta) => {
              if (meta && meta.conversationId) {
                this.setStoredDifyConversationId(meta.conversationId)
                this.difyConversationId = meta.conversationId
              }
            },
            signal: abortController.signal,
          })
          this.sendContactInfoRequest()
        } catch (error) {
          if (error && error.name === 'AbortError') {
            return
          }
          console.error("Dify请求失败:", error);
          assistantMsg.content =
            assistantMsg.content ||
            "Sorry, the customer service system is currently unavailable. Please try again later."
          this.$message.error(this.$t('globalContactForm.networkError'))
          this.sendContactInfoRequest()
        } finally {
          if (this.difyAbortController === abortController) {
            this.difyAbortController = null
          }
          this.isSending = false
        }
        return
      }

      this.messages.push({
        type: "service",
        avatar: require("../../assets/chatlogo.png"),
        name: "service 001",
        time: new Date().toLocaleString(),
        content: "AI 服务未配置，暂时无法发送消息。",
      });
      this.$nextTick(this.scrollToBottom);
    },
    canUseDify() {
      return !!process.env.VUE_APP_DIFY_API_KEY
    },
    getOrCreateDifyUserId() {
      const key = 'difyUserId'
      try {
        const existing = localStorage.getItem(key)
        if (existing) return existing
        const value = `u_${Date.now()}_${Math.random().toString(16).slice(2)}`
        localStorage.setItem(key, value)
        return value
      } catch (e) {
        return `u_${Date.now()}_${Math.random().toString(16).slice(2)}`
      }
    },
    getStoredDifyConversationId() {
      const key = 'difyConversationId'
      try {
        return localStorage.getItem(key) || ''
      } catch (e) {
        return ''
      }
    },
    setStoredDifyConversationId(conversationId) {
      const key = 'difyConversationId'
      try {
        if (conversationId) {
          localStorage.setItem(key, conversationId)
        } else {
          localStorage.removeItem(key)
        }
      } catch (e) {
        void e
      }
    },
    scrollToBottom() {
      if (this.$refs.chatContent) {
        this.$refs.chatContent.scrollTop = this.$refs.chatContent.scrollHeight;
      }
    },
    selectQuestion(q) {
      this.inputMessage = q;
      this.sendMessage();
    },
    checkMobileDevice() {
      const width = window.innerWidth;
      const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      // 设备分类
      this.isMobile = width <= 768 || (isMobileUA && width <= 768);
      this.isTablet = width > 768 && width <= 1024;
      this.isLaptop = width > 1024 && width <= 1440;
      // 桌面端: width > 1440
    },
    adjustWindowSize() {
      this.checkMobileDevice();
      if (this.expanded) {
        // 滚动到底部
        this.$nextTick(this.scrollToBottom);
      }
    },
    handleQuestionClick(item) {
      this.inputMessage = item;
      this.sendMessage();
      // 选择问题后自动收缩
      this.guessExpanded = false;
    },
    toggleGuessExpanded() {
      this.guessExpanded = !this.guessExpanded;
    },
    // 新增：切换语言
    switchLanguage(lang) {
      this.currentLanguage = lang;
    },
    // 新增：切换语言（简化版本）
    toggleLanguage() {
      this.currentLanguage = this.currentLanguage === 'en' ? 'zh' : 'en';
      console.log('切换语言到:', this.currentLanguage);
    },
    // 新增：获取问题
    async fetchQuestions() {
      this.loading = true;
      this.error = false;
      console.log('开始获取问题数据...');
      try {
        const response = await fetch(`/api/questionAnswer/getquestion`);
        console.log('API响应状态:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        console.log('API返回的原始数据:', result);
        console.log('数据类型:', typeof result, '是否为数组:', Array.isArray(result));

        // 处理标准的API响应格式 {code, message, data}
        if (result && result.code === 200 && result.data) {
          console.log('检测到标准API响应格式');
          console.log('result.data类型:', typeof result.data, '是否为数组:', Array.isArray(result.data));
          console.log('result.data长度:', result.data.length);

          if (Array.isArray(result.data) && result.data.length > 0) {
            // 验证数据结构
            const validQuestions = result.data.filter((item, index) => {
              const isValid = item && item.question;
              if (index < 5) {
                console.log(`API数据验证[${index}]:`, {
                  item存在: !!item,
                  question属性: item?.question,
                  是否有效: isValid
                });
              }
              return isValid;
            });

            if (validQuestions.length > 0) {
              this.questions = validQuestions;
              console.log('成功加载API数据，有效问题数量:', validQuestions.length);
              console.log('前3个问题:', validQuestions.slice(0, 3).map(q => q.question));
            } else {
              console.log('API数据中没有有效问题，保留测试数据');
            }
          } else {
            console.log('result.data不是有效数组，保留测试数据');
          }
        } else {
          console.log('API响应格式不正确，尝试其他格式处理...');

          // 兼容处理：如果直接返回数组
          if (Array.isArray(result) && result.length > 0) {
            console.log('检测到直接数组格式');
            const validQuestions = result.filter((item, index) => {
              const isValid = item && item.question;
              if (index < 5) {
                console.log(`直接数组验证[${index}]:`, {
                  item存在: !!item,
                  question属性: item?.question,
                  是否有效: isValid
                });
              }
              return isValid;
            });

            if (validQuestions.length > 0) {
              this.questions = validQuestions;
              console.log('使用直接数组数据，有效问题数量:', validQuestions.length);
            }
          } else {
            console.log('无法识别的数据格式，保留测试数据');
          }
        }

        console.log('最终的questions长度:', this.questions.length);
        console.log('最终questions前3个:', this.questions.slice(0, 3));
      } catch (error) {
        console.error("Failed to fetch questions:", error);
        this.error = true;
        console.log('API失败，保留测试数据');
      } finally {
        this.loading = false;
        console.log('加载完成，loading:', this.loading, 'error:', this.error);
      }
    },

    // 新增：发送联系信息请求消息
    sendContactInfoRequest() {
      // 避免重复发送联系信息请求
      if (this.hasSentContactRequest) {
        return;
      }

      this.hasSentContactRequest = true;

      setTimeout(() => {
        this.messages.push({
          type: "service",
          avatar: require("../../assets/chatlogo.png"),
          name: "service 001",
          time: new Date().toLocaleString(),
          content: this.contactInfoMessage,
        });
        this.$nextTick(this.scrollToBottom);
      }, 2000);
    },
    // 取消邮箱门禁
    cancelEmailGate() {
      // 直接收起聊天窗口
      this.emailGateVisible = false;
      this.expanded = false;
    },
    // 使用用户提供的方法提交邮箱
    async handleSubmit() {
      if (this.emailInput && this.emailInput.trim()) {
        // 简单的邮箱格式验证
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.emailInput.trim())) {
          this.$message.warning(this.$t('globalContactForm.validation.emailFormat'));
          return;
        }

        try {
          const email = this.emailInput.trim();
          console.log('开始提交邮箱:', email);

          const result = await emailSubmitApi.submitEmail(email);
          console.log('邮箱提交接口响应:', result);

          const ok =
            result &&
            (result.code === 200 ||
              result.success === true ||
              result.ok === true);

          if (!ok) {
            this.$message.error(
              (result && (result.message || result.msg)) ||
              this.$t('globalContactForm.error')
            );
            return;
          }

          this.$message.success(this.$t('globalContactForm.success'));
          this.emailSubmitted = true;
          try { localStorage.setItem('chatEmailSubmitted', 'true'); } catch (e) { console.warn('localStorage 写入失败:', e); }
          this.emailGateVisible = false;
          this.emailInput = '';
          this.messages.push({
            type: 'service',
            avatar: require('../../assets/chatlogo.png'),
            name: 'service 001',
            time: new Date().toLocaleString(),
            content: this.$t('chatService.emailGate.successMessage')
          });
          this.$nextTick(this.scrollToBottom);
        } catch (error) {
          console.error('提交邮箱时出错:', error);
          this.$message.error(this.$t('globalContactForm.error'));
        }
      } else {
        this.$message.warning(this.$t('globalContactForm.validation.email'));
      }
    }
  },
  computed: {
    filteredQuestions() {
      console.log('filteredQuestions被调用，questions数量:', this.questions?.length, 'currentLanguage:', this.currentLanguage);
      // 确保questions是数组
      if (!this.questions || !Array.isArray(this.questions) || this.questions.length === 0) {
        console.log('questions为空或不是数组，返回空数组');
        return [];
      }

      // 根据当前语言过滤问题
      const filtered = this.questions.filter(question => {
        // 确保question对象存在且有question属性
        if (!question || !question.question) {
          return false;
        }

        // 确保question.question是字符串
        const questionText = String(question.question);

        if (this.currentLanguage === 'zh') {
          // 检查是否包含中文字符
          return /[\u4e00-\u9fa5]/.test(questionText);
        } else {
          // 检查是否主要是英文（不包含中文字符或中文字符很少）
          const chineseChars = (questionText.match(/[\u4e00-\u9fa5]/g) || []).length;
          const totalChars = questionText.length;
          const chineseRatio = chineseChars / totalChars;
          return chineseRatio < 0.3; // 中文字符占比小于30%视为英文
        }
      });

      console.log(`过滤后的${this.currentLanguage}问题数量:`, filtered.length);
      return filtered;
    }
  }
};
</script>

<style scoped>
.chat-service-container {
  position: fixed;
  z-index: 9999;
}

/* 悬浮图标样式 - 固定在右边中间 */
.chat-icon-wrapper {
  position: fixed;
  right: 2%;
  top: 35%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 9999;

  /* overflow: hidden; 确保波纹效果不会溢出 */
}

.chat-icon-wrapper:hover {
  transform: translateY(-50%) scale(1.05);
}

.chat-icon {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1; /* 确保图标在波纹之上 */
}

.chat-icon img {
  width: 150px;
  height: 100%;
  border-radius: 50%;
  object-fit: contain;
  display: block;
  margin-bottom: -30px;
  transition: transform 0.3s ease;
  animation: shake 2s ease-in-out infinite; /* 添加晃动动画 */
}

.chat-icon:hover img {
  transform: scale(1.05);
}

/* 头像晃动动画 */
@keyframes shake {
  0%,
  100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-5deg);
  }
  75% {
    transform: rotate(5deg);
  }
}

.ripple-effect,
.ripple-effect-2 {
  position: absolute;
  border-radius: 50%;
  background: rgba(79, 157, 166, 0.3); /* 波纹颜色 */
  animation: ripple 1.5s ease-out infinite;
  opacity: 0;
}

.ripple-effect {
  width: 100px;
  height: 100px;
  top: -25px;
  left: -25px;
}

.ripple-effect-2 {
  width: 150px;
  height: 150px;
  top: -50px;
  left: -50px;
  animation-delay: 0.5s;
}

@keyframes ripple {
  to {
    transform: scale(1.5);
    opacity: 0;
  }
}

.chat-now-label {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateY(130%);
  background-color: #4f9da6;
  color: white;
  padding: 5px 10px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;
  z-index: 2; /* 确保标签在波纹和图标之上 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* 消息气泡样式 */
.message-bubble {
  position: absolute;
  right: 0;
  top: 20px;
  transform: translate(50%, -50%);
  z-index: 10;
  animation: bubble-appear 0.5s ease-out;
}

.bubble-content {
  position: relative;
  background-color: #ff4757;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(255, 71, 87, 0.3);
  animation: pulse 2s infinite;
}

.bubble-number {
  color: white;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 2px 8px rgba(255, 71, 87, 0.3);
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(255, 71, 87, 0.5);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 2px 8px rgba(255, 71, 87, 0.3);
  }
}

/* 消息气泡出现动画 */
@keyframes bubble-appear {
  0% {
    opacity: 0;
    transform: translateY(-50%) scale(0.8);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
}

/* 聊天窗口样式 */
.chat-window {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 500px;
  height: 600px;
  max-height: 90vh;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 9999;
}

/* 移动端适配 */
.chat-window.mobile {
  position: fixed;
  top: 5vh;
  left: 5vw;
  right: 5vw;
  bottom: 5vh;
  width: auto;
  height: auto;
  max-width: none;
  max-height: none;
  transform: none;
  border-radius: 16px;
}

/* 平板端适配 */
.chat-window.tablet {
  position: fixed;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  width: 420px;
  height: 650px;
  max-height: 85vh;
  border-radius: 12px;
}

/* 笔记本端适配 */
.chat-window.laptop {
  position: fixed;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  width: 460px;
  height: 700px;
  max-height: 90vh;
  border-radius: 10px;
}

/* 超大屏幕适配 */
@media (min-width: 1441px) {
  .chat-window {
    right: 30px;
    width: 520px;
    height: 750px;
  }
}

/* 移动端图标调整 */
@media (max-width: 768px) {
  .chat-icon-wrapper {
    right: 15px;
    width: 50px;
    height: 50px;
  }

  .chat-icon img {
    width: 100%;
    height: 100%;
  }

  .ripple-effect {
    width: 80px;
    height: 80px;
    top: -15px;
    left: -15px;
  }

  .ripple-effect-2 {
    width: 110px;
    height: 110px;
    top: -30px;
    left: -30px;
  }

  .chat-now-label {
    font-size: 10px;
    padding: 3px 8px;
  }

  .message-bubble {
    right: 60px;
  }

  .bubble-content {
    width: 20px;
    height: 20px;
  }

  .bubble-number {
    font-size: 10px;
  }
}

/* 平板端图标调整 */
@media (min-width: 769px) and (max-width: 1024px) {
  .chat-icon-wrapper {
    right: 20px;
    width: 55px;
    height: 55px;
  }

  .chat-icon img {
    width: 100%;
    height: 100%;
  }

  .ripple-effect {
    width: 85px;
    height: 85px;
    top: -15px;
    left: -15px;
  }

  .ripple-effect-2 {
    width: 120px;
    height: 120px;
    top: -32px;
    left: -32px;
  }

  .chat-now-label {
    font-size: 11px;
    padding: 4px 9px;
  }

  .message-bubble {
    right: 65px;
  }

  .bubble-content {
    width: 22px;
    height: 22px;
  }

  .bubble-number {
    font-size: 11px;
  }

  .loading-state,
  .error-state {
    padding: 25px 12px;
    font-size: 11px;
  }
}

/* 笔记本端图标调整 */
@media (min-width: 1025px) and (max-width: 1440px) {
  .chat-icon-wrapper {
    right: 22px;
    width: 58px;
    height: 58px;
  }

  .chat-icon img {
    width: 100%;
    height: 100%;
  }

  .ripple-effect {
    width: 90px;
    height: 90px;
    top: -16px;
    left: -16px;
  }

  .ripple-effect-2 {
    width: 130px;
    height: 130px;
    top: -36px;
    left: -36px;
  }

  .chat-now-label {
    font-size: 11px;
    padding: 4px 9px;
  }

  .message-bubble {
    right: 48px;
    top: 30px;
  }

  .bubble-content {
    width: 24px;
    height: 24px;
  }

  .bubble-number {
    font-size: 12px;
  }

  .loading-state,
  .error-state {
    padding: 28px 14px;
    font-size: 12px;
  }
}

/* 头部样式 */
.chat-header {
  height: 80px;
  background: linear-gradient(to right, #7dd4de, #4f9da6);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  color: white;
  flex-shrink: 0;
}

/* 移动端头部调整 */
@media (max-width: 768px) {
  .chat-header {
    height: 70px;
    padding: 0 15px;
  }

  .header-icon {
    width: 50px !important;
    height: 50px !important;
    margin-right: 10px !important;
  }

  .header-title {
    font-size: 12px !important;
  }

  .header-status {
    font-size: 11px !important;
  }
}

/* 平板端头部调整 */
@media (min-width: 769px) and (max-width: 1024px) {
  .chat-header {
    height: 75px;
    padding: 0 18px;
  }

  .header-icon {
    width: 60px !important;
    height: 60px !important;
    margin-right: 12px !important;
  }

  .header-title {
    font-size: 13px !important;
  }

  .header-status {
    font-size: 12px !important;
  }
}

/* 笔记本端头部调整 */
@media (min-width: 1025px) and (max-width: 1440px) {
  .chat-header {
    height: 78px;
    padding: 0 20px;
  }

  .header-icon {
    width: 70px !important;
    height: 70px !important;
    margin-right: 14px !important;
  }

  .header-title {
    font-size: 14px !important;
  }

  .header-status {
    font-size: 13px !important;
  }
}

.header-left {
  display: flex;
  align-items: center;
}

.header-icon {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  margin-right: 15px;
}

.header-info {
  display: flex;
  flex-direction: column;
}

.header-title {
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 5px;
}

.header-status {
  font-size: 14px;
  opacity: 0.8;
}

.status-connected {
  color: #4caf50;
}

.status-disconnected {
  color: #ffa726;
}

.header-right {
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.header-right:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* 聊天内容区域 */
.chat-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background-color: #fff;
  min-height: 0;
}

/* 自定义滚动条 */
.chat-content::-webkit-scrollbar {
  width: 6px;
}

.chat-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.chat-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.chat-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 移动端聊天内容调整 */
@media (max-width: 768px) {
  .chat-content {
    padding: 15px 10px;
  }

  .message-item {
    margin-bottom: 15px;
    max-width: 85%;
  }

  .message-avatar {
    margin-right: 8px;
  }

  .message-item.service .message-avatar {
    width: 30px !important;
    height: 30px !important;
    margin-right: 8px !important;
  }

  .message-item.user .message-avatar {
    width: 16px !important;
    height: 18px !important;
    margin-left: 8px !important;
  }

  .message-name {
    font-size: 12px !important;
    margin-right: 8px !important;
  }

  .message-time {
    font-size: 10px !important;
  }

  .message-content {
    padding: 10px 12px !important;
    font-size: 13px !important;
    border-radius: 6px !important;
  }

  .message-item.service .message-content {
    margin-left: 38px !important;
  }

  .message-item.user .message-content {
    margin-right: 32px !important;
  }
}

/* 平板端聊天内容调整 */
@media (min-width: 769px) and (max-width: 1024px) {
  .chat-content {
    padding: 18px 15px;
  }

  .message-item {
    margin-bottom: 18px;
    max-width: 80%;
  }

  .message-item.service .message-avatar {
    width: 35px !important;
    height: 35px !important;
    margin-right: 9px !important;
  }

  .message-item.user .message-avatar {
    width: 18px !important;
    height: 19px !important;
    margin-left: 9px !important;
  }

  .message-name {
    font-size: 13px !important;
    margin-right: 9px !important;
  }

  .message-time {
    font-size: 11px !important;
  }

  .message-content {
    padding: 11px 13px !important;
    font-size: 14px !important;
  }

  .message-item.service .message-content {
    margin-left: 44px !important;
  }

  .message-item.user .message-content {
    margin-right: 36px !important;
  }
}

/* 笔记本端聊天内容调整 */
@media (min-width: 1025px) and (max-width: 1440px) {
  .chat-content {
    padding: 20px 18px;
  }

  .message-item {
    margin-bottom: 20px;
    max-width: 78%;
  }

  .message-item.service .message-avatar {
    width: 37px !important;
    height: 37px !important;
    margin-right: 10px !important;
  }

  .message-item.user .message-avatar {
    width: 19px !important;
    height: 20px !important;
    margin-left: 10px !important;
  }

  .message-name {
    font-size: 14px !important;
    margin-right: 10px !important;
  }

  .message-time {
    font-size: 12px !important;
  }

  .message-content {
    padding: 12px 14px !important;
    font-size: 14px !important;
  }

  .message-item.service .message-content {
    margin-left: 47px !important;
  }

  .message-item.user .message-content {
    margin-right: 39px !important;
  }
}

.message-item {
  margin-bottom: 20px;
  max-width: 80%;
}

.message-item.service {
  align-self: flex-start;
}

.message-item.user {
  align-self: flex-end;
  margin-left: auto;
}

.message-info {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.message-info.user {
  justify-content: flex-end;
  flex-direction: row;
}

.message-avatar {
  border-radius: 50%;
  margin-right: 10px;
}

.message-item.service .message-avatar {
  width: 39px;
  height: 39px;
  margin-right: 10px;
}

.message-item.user .message-avatar {
  width: 20px;
  height: 20px;
  background-color: #52a1aa;
  padding: 5px;
  margin-right: 0;
  margin-left: 10px;
}

.message-name {
  font-size: 14px;
  font-weight: bold;
  margin-right: 10px;
  color: #4f9da6;
}

.message-item.user .message-name {
  margin-right: 10px;
  margin-left: 0;
}

.message-time {
  font-size: 12px;
  color: #999;
}

.message-item.user .message-time {
  margin-right: 10px;
}

.message-content {
  padding: 12px 15px;
  border-radius: 8px;
  background-color: #f1f8f8;
  /* box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); */
  word-break: break-word;
  white-space: pre-line;
  line-height: 1.5;
}

.message-item.service .message-content {
  margin-left: 49px;
}

.message-item.user .message-content {
  background: linear-gradient(to right, #4f9da6, #7dd4de);
  color: white;
  margin-left: 0;
  margin-right: 40px;
}

/* 猜你想问区域 */
.guess-questions {
  margin: 15px 20px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

/* 收缩状态 */
.guess-questions.collapsed {
  margin: 15px 20px 15px auto;
  width: 50px;
  height: 50px;
}

/* 圆形按钮 */
.guess-circle-btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4f9da6, #7dd4de);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(79, 157, 166, 0.3);
  transition: all 0.3s ease;
  position: relative;
}

.guess-circle-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(79, 157, 166, 0.4);
}

.guess-circle-btn .guess-icon {
  width: 20px;
  height: 20px;
  background-image: url("../../assets/problem.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  filter: brightness(0) invert(1); /* 使图标变白色 */
}

/* 展开状态 */
.guess-expanded {
  padding: 15px 20px;
  background-color: #e8f4f5;
  border-radius: 8px;
  position: relative;
  animation: expandIn 0.3s ease;
}

@keyframes expandIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* 关闭按钮 */
.close-guess-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: rgba(79, 157, 166, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.close-guess-btn:hover {
  background-color: rgba(79, 157, 166, 0.2);
}

.close-icon {
  font-size: 16px;
  color: #4f9da6;
  font-weight: bold;
  line-height: 1;
}

/* 展开状态下的样式 */
.guess-expanded .guess-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  font-size: 14px;
  padding-right: 30px; /* 为关闭按钮留出空间 */
  flex-wrap: nowrap;
}

.guess-expanded .guess-header span:first-child {
  color: #000;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.guess-expanded .guess-icon {
  width: 13px;
  height: 13px;
  margin-right: 6px;
  background-image: url("../../assets/problem.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  filter: none; /* 恢复原色 */
}

.refresh-btn {
  color: #4f9da6;
  cursor: pointer;
  font-size: 13px;
  display: flex;
  align-items: center;
  padding: 2px 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.refresh-btn:hover {
  background-color: rgba(79, 157, 166, 0.1);
}

.refresh-icon {
  width: 13px;
  height: 13px;
  margin-right: 4px;
  background-image: url("../../assets/other.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.back-icon {
  width: 13px;
  height: 13px;
  margin-right: 4px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDEySDVNMTIgMTlMNSAxMkwxMiA1IiBzdHJva2U9IiM0RjlEQTYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.question-list {
  display: flex;
  flex-direction: column;
  gap: 0px;
  max-height: 180px;
  overflow-y: auto;
  padding-right: 5px;
}

/* 自定义滚动条样式 */
.question-list::-webkit-scrollbar {
  width: 4px;
}

.question-list::-webkit-scrollbar-track {
  background: rgba(79, 157, 166, 0.1);
  border-radius: 2px;
}

.question-list::-webkit-scrollbar-thumb {
  background: rgba(79, 157, 166, 0.4);
  border-radius: 2px;
}

.question-list::-webkit-scrollbar-thumb:hover {
  background: rgba(79, 157, 166, 0.6);
}

.category-section {
  margin-bottom: 5px;
}

.category-header {
  font-weight: bold;
  background-color: rgba(79, 157, 166, 0.05);
}

.category-header:hover {
  background-color: rgba(79, 157, 166, 0.15);
}

.sub-questions {
  padding-left: 15px;
  border-left: 2px solid rgba(79, 157, 166, 0.2);
  margin-left: 10px;
}

.sub-question {
  margin-bottom: -3px;
  font-size: 12px;
  opacity: 0.9;
}

.sub-question::before {
  content: "◦";
  color: #4f9da6;
  font-size: 14px;
  margin-right: 8px;
  line-height: 1;
}

.arrow-right {
  margin-left: auto;
  width: 0;
  height: 0;
  border-left: 6px solid #4f9da6;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  transition: transform 0.2s ease;
}

.arrow-right.rotated {
  transform: rotate(90deg);
}

.question-item {
  padding: 10px 12px;
  color: #4f9da6;
  border-radius: 6px;
  margin-bottom: -5px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  position: relative;
}

.question-item::before {
  content: "•";
  color: #4f9da6;
  font-size: 16px;
  margin-right: 8px;
  line-height: 1;
}

.question-item:hover {
  background-color: rgba(81, 160, 169, 0.1);
  border-color: rgba(79, 157, 166, 0.2);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .guess-questions.collapsed {
    margin: 10px 15px 10px auto;
    width: 45px;
    height: 45px;
  }

  .guess-circle-btn {
    width: 45px;
    height: 45px;
  }

  .guess-circle-btn .guess-icon {
    width: 18px;
    height: 18px;
  }

  .guess-expanded {
    margin: 10px;
    padding: 10px 15px;
  }

  .guess-expanded .guess-header {
    margin-bottom: 10px !important;
    font-size: 12px !important;
  }

  .question-list {
    max-height: 140px !important;
  }

  .question-item {
    padding: 8px 10px !important;
    font-size: 11px !important;
    margin-bottom: -3px !important;
  }

  .question-item::before {
    font-size: 12px !important;
    margin-right: 6px !important;
  }

  .sub-question {
    font-size: 10px !important;
  }

  .sub-questions {
    padding-left: 12px !important;
    margin-left: 8px !important;
  }
}

/* 平板端适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .guess-questions.collapsed {
    margin: 12px 18px 12px auto;
  }

  .guess-expanded {
    margin: 12px 15px;
    padding: 12px 18px;
  }

  .guess-expanded .guess-header {
    margin-bottom: 12px !important;
    font-size: 13px !important;
  }

  .question-list {
    max-height: 160px !important;
  }

  .question-item {
    padding: 9px 11px !important;
    font-size: 12px !important;
    margin-bottom: -4px !important;
  }

  .question-item::before {
    font-size: 14px !important;
    margin-right: 7px !important;
  }

  .sub-question {
    font-size: 11px !important;
  }

  .sub-questions {
    padding-left: 13px !important;
    margin-left: 9px !important;
  }
}

/* 笔记本端适配 */
@media (min-width: 1025px) and (max-width: 1440px) {
  .guess-questions.collapsed {
    margin: 15px 20px 15px auto;
  }

  .guess-expanded {
    margin: 15px 18px;
    padding: 14px 20px;
  }

  .guess-expanded .guess-header {
    margin-bottom: 14px !important;
    font-size: 14px !important;
  }

  .question-list {
    max-height: 170px !important;
  }

  .question-item {
    padding: 9px 12px !important;
    font-size: 13px !important;
    margin-bottom: -4px !important;
  }

  .question-item::before {
    font-size: 15px !important;
    margin-right: 8px !important;
  }

  .sub-question {
    font-size: 12px !important;
  }

  .sub-questions {
    padding-left: 14px !important;
    margin-left: 9px !important;
  }
}

/* 输入区域 */
.chat-input-area {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #f7f6f6;
  box-sizing: border-box;
  flex-shrink: 0;
}

/* 语言提示样式 */
.language-tip {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
  text-align: left;
  opacity: 0.8;
}

/* 输入行样式 */
.input-row {
  display: flex;
  align-items: center;
}

/* 移动端输入区域调整 */
@media (max-width: 768px) {
  .chat-input-area {
    padding: 15px 10px;
  }

  .language-tip {
    font-size: 11px;
    margin-bottom: 6px;
  }

  .chat-input {
    height: 36px !important;
    font-size: 13px !important;
    padding: 0 12px !important;
  }

  .send-btn {
    height: 36px !important;
    padding: 0 15px !important;
    margin-left: 8px !important;
    font-size: 13px !important;
  }

  .send-icon {
    width: 16px !important;
    height: 16px !important;
    margin-right: 3px !important;
  }
}

/* 平板端输入区域调整 */
@media (min-width: 769px) and (max-width: 1024px) {
  .chat-input-area {
    padding: 18px 15px;
  }

  .language-tip {
    font-size: 11px;
    margin-bottom: 7px;
  }

  .chat-input {
    height: 38px !important;
    font-size: 14px !important;
    padding: 0 14px !important;
  }

  .send-btn {
    height: 38px !important;
    padding: 0 18px !important;
    margin-left: 10px !important;
    font-size: 14px !important;
  }

  .send-icon {
    width: 18px !important;
    height: 18px !important;
    margin-right: 4px !important;
  }
}

/* 笔记本端输入区域调整 */
@media (min-width: 1025px) and (max-width: 1440px) {
  .chat-input-area {
    padding: 20px 18px;
  }

  .language-tip {
    font-size: 12px;
    margin-bottom: 8px;
  }

  .chat-input {
    height: 39px !important;
    font-size: 14px !important;
    padding: 0 15px !important;
  }

  .send-btn {
    height: 39px !important;
    padding: 0 19px !important;
    margin-left: 10px !important;
    font-size: 14px !important;
  }

  .send-icon {
    width: 19px !important;
    height: 19px !important;
    margin-right: 5px !important;
  }
}

.chat-input {
  flex: 1;
  height: 40px;
  padding: 0 15px;
  border: 1px solid #e0e0e0;
  background-color: #ffffff;
  border-radius: 20px;
  outline: none;
  font-size: 14px;
  transition: border-color 0.2s;
}

.chat-input:focus {
  border-color: #4f9da6;
}

.send-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  padding: 0 20px;
  height: 40px;
  border-radius: 20px;
  background: linear-gradient(to right, #4f9da6, #7dd4de);
  color: white;
  cursor: pointer;
  transition: opacity 0.2s;
  border: none;
  font-weight: 500;
}

.send-btn:hover {
  opacity: 0.9;
}

.send-btn:active {
  transform: scale(0.98);
}

.send-icon {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

/* 语言切换按钮样式 */
.lang-toggle-btn {
  padding: 6px 12px;
  border: 1px solid #4f9da6;
  background: #fff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s ease;
  color: #4f9da6;
  font-weight: 500;
  min-width: 40px;
}

.lang-toggle-btn:hover {
  background: #4f9da6;
  color: #fff;
}

.lang-toggle-btn:active {
  transform: scale(0.95);
}

/* 移动端语言切换按钮适配 */
@media (max-width: 768px) {
  .lang-toggle-btn {
    padding: 4px 8px;
    font-size: 11px;
    min-width: 35px;
  }
}

/* 平板端语言切换按钮适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .lang-toggle-btn {
    padding: 5px 10px;
    font-size: 11px;
    min-width: 38px;
  }
}

/* 加载状态样式 */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 15px;
  color: #666;
  font-size: 12px;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #4f9da6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 错误状态样式 */
.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 15px;
  color: #666;
  font-size: 12px;
}

.retry-btn {
  margin-top: 10px;
  padding: 6px 12px;
  background: #4f9da6;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  transition: background 0.2s ease;
}

.retry-btn:hover {
  background: #45878f;
}

/* 移动端语言切换按钮适配 */
@media (max-width: 768px) {
  .loading-state,
  .error-state {
    padding: 20px 10px;
    font-size: 11px;
  }

  .loading-spinner {
    width: 16px;
    height: 16px;
    margin-bottom: 8px;
  }

  .retry-btn {
    padding: 5px 10px;
    font-size: 10px;
  }
}

/* 平板端语言切换按钮适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .loading-state,
  .error-state {
    padding: 25px 12px;
    font-size: 11px;
  }

  .loading-spinner {
    width: 18px;
    height: 18px;
    margin-bottom: 9px;
  }

  .retry-btn {
    padding: 5px 11px;
    font-size: 10px;
  }
}

/* 笔记本端语言切换按钮适配 */
@media (min-width: 1025px) and (max-width: 1440px) {
  .loading-state,
  .error-state {
    padding: 28px 14px;
    font-size: 12px;
  }

  .loading-spinner {
    width: 19px;
    height: 19px;
    margin-bottom: 9px;
  }

  .retry-btn {
    padding: 6px 11px;
    font-size: 11px;
  }
}

/* 确保在所有设备上聊天窗口都不会被遮挡 */
@media (max-height: 600px) {
  .chat-window {
    top: 10px;
    bottom: 10px;
    height: auto;
    transform: none;
  }

  .chat-window.mobile {
    top: 10px;
    bottom: 10px;
  }
}

/* 横屏模式适配 */
@media (orientation: landscape) and (max-height: 600px) {
  .chat-window {
    top: 5px;
    bottom: 5px;
    height: auto;
    transform: none;
  }

  .chat-window.mobile {
    top: 5px;
    bottom: 5px;
  }

  .chat-header {
    height: 60px !important;
  }

  .guess-questions {
    padding: 10px 15px !important;
    margin: 10px 15px !important;
  }

  .chat-input-area {
    padding: 10px 15px !important;
  }
}

/* 邮箱门禁遮罩层样式 */
.email-gate-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.email-gate-dialog {
  width: 88%;
  max-width: 520px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  padding: 20px 18px;
}

.email-gate-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.email-gate-desc {
  margin-top: 8px;
  font-size: 13px;
  color: #666;
}

.email-gate-form {
  margin-top: 14px;
}

.email-input {
  width: 90%;
  height: 40px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 14px;
  outline: none;
}

.email-input:focus {
  border-color: #4f9da6;
}

.email-gate-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}

.email-submit-btn,
.email-cancel-btn {
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 13px;
}

.email-submit-btn {
  background: linear-gradient(to right, #4f9da6, #7dd4de);
  color: #fff;
}

.email-cancel-btn {
  background: #f1f1f1;
  color: #333;
}
</style>
